module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"related_videos":"Related Videos"},"ja":{"related_videos":"関連動画"}}')
  delete Component.options._Ctor
}
